import { BaseFrameworkError } from "@bloglovin/vue-framework";

class PublicationError extends BaseFrameworkError {}

export default PublicationError;
